import Store from '../../../../interfaces/Store';
import update from 'immutability-helper';
import { Theme } from '../../../../interfaces/Theme';
import { MediaModuleColorHack } from '../../../../services/mediaModuleColorHack';

export const setThemeReducer = (
  state: Store,
  { material, ralValue }: { material: string; ralValue: string }
): Store => {
  const articles = state.configuration.articles.map(article => {
    const updatedArticle = {
      ...article,
      colors: article.colors.map(color =>
        color.affectedMaterial === material ? { ...color, ralValue } : color
      )
    };
    // Apply the same color to media modules if color of support column got changed.
    // When hack is no longer needed just remove this line
    state = MediaModuleColorHack.applyOnColorChange(state, updatedArticle);
    return updatedArticle;
  });

  const newTheme: Theme = {
    ...state.configuration.theme,
    [material]: ralValue
  };

  return update(state, {
    configuration: {
      articles: { $set: articles },
      theme: { $set: newTheme }
    }
  });
};
